const awsmobile = {
  aws_project_region: 'eu-west-2',
  aws_cognito_region: 'eu-west-2',
  aws_user_pools_id: 'eu-west-2_guif8M0eU',
  aws_user_pools_web_client_id: '62tugs7tk8paai4qlt9pavbftd',
  aws_cognito_identity_pool_id: 'eu-west-2:a6985c87-44e6-4e59-aca7-79b45bbd3163',
  oauth: {},
  aws_cloud_logic_custom: [
    {
      name: 'blockblastapi',
      endpoint: 'https://z5iuh4uz09.execute-api.eu-west-2.amazonaws.com/blockblast',
      region: 'eu-west-2',
    },
  ],
};

export default awsmobile;
